<template>
  <component
    :is="tag"
    v-if="showPaymentStatus"
    class="chip-smaller"
    :class="{
      'text-center': center,
      'px-2': center
    }"
    v-bind="$attrs"
  >
    <AppChip :color="chipColor" text-color="white--text">
      {{ chipText }}
    </AppChip>
  </component>
</template>
<script>
import gql from "fraql";
import AppChip from "@elements/AppChip.vue";
export default {
  name: "AppShowPaymentStatus",
  components: { AppChip },
  props: {
    status: {
      type: String,
      default: null
    },
    ignore: {
      type: Array,
      default: () => []
    },
    possibleValues: {
      type: Array,
      default: () => []
    },
    center: {
      type: Boolean,
      default: true
    },
    paidExternally: {
      // For registration competition payment
      type: Boolean,
      default: false
    },
    regEventProductPaidExternally: {
      // For registration event product payment
      type: Boolean,
      default: false
    },
    tag: {
      type: String,
      default: "div"
    }
  },
  computed: {
    showPaymentStatus() {
      if (this.paidExternally || this.regEventProductPaidExternally)
        return true;

      if (this.status) {
        if (this.possibleValues.length > 0) {
          return this.possibleValues.includes(this.status);
        } else if (this.ignore.length > 0) {
          return !this.ignore.includes(this.status);
        } else {
          return true;
        }
      }

      return false;
    },
    chipText() {
      if (this.regEventProductPaidExternally) {
        return this.$t(
          "events:products.productPaidExternally.chip",
          "Paid externally"
        );
      }
      if (this.paidExternally) {
        return this.$t("common:paidInShowOffice.badge", "Paid in show office");
      }
      switch (this.status) {
        case "NOT_PAID":
          return this.$t("common:notpaid.badge", "Not paid");
        case "IN_PROGRESS":
          return this.$t("common:inprocess.badge", "In process");
        case "PENDING":
          return this.$t("common:pending.badge", "Pending");
        case "PROCESSING":
          return this.$t("common:processing.badge", "Processing");
        case "PAID":
          return this.$t("common:paid.badge", "Paid");
        case "PARTIALLY_REFUNDED":
        case "FULLY_REFUNDED":
          return this.$t(`common:paymentStatus.` + this.status);
        case "CANCELLED":
          return this.$t(`wallet:payment.status.CANCELLED.label`);
      }

      return "";
    },
    chipColor() {
      if (this.paidExternally || this.regEventProductPaidExternally) {
        return "edit-green";
      }
      switch (this.status) {
        case "NOT_PAID":
          return "secondary";
        case "IN_PROGRESS":
        case "PENDING":
        case "WARNING":
        case "CANCELLED":
          return "edit";
        case "PAID":
          return "edit-green";
        case "PARTIALLY_REFUNDED":
        case "FULLY_REFUNDED":
          return "grey";
        default:
          return "grey";
      }
    }
  },
  fragments: {
    entryFields: gql`
      fragment _ on Entry {
        paymentStatus
        paidExternally
      }
    `,
    registrationEventProductFields: gql`
      fragment _ on RegistrationEventProduct {
        paymentStatus
        paidExternally
      }
    `
  }
};
</script>
